/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionActivePolicySearchCompanyQuery from '../graphql/queries/GetSouscriptionActivePolicySearchCompanyQuery.js';

const useGetSouscriptionActivePolicySearchCompanyQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionActivePolicySearchCompanyQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionActivePolicySearchCompany: R.omit(['__typename'], data?.getSouscriptionActivePolicySearchCompany_souscription_active_policy || {})
  };
};

export default useGetSouscriptionActivePolicySearchCompanyQuery;
